module.exports = __webpack_public_path__ + "img/security_flatline.e9894daf.svg";